@let expertise = store.serviceExpertise$ | async;
@if (expertise) {
    <div class="input-grid input-grid-gaps w-full">
        <app-text-input [form]="form" id="insuranceNumber"
            [disabled]="person?.insuranceNumber !== null"></app-text-input>
        <app-insurance-company-select-input
            [form]="form"
            class="fr-2"
            id="insuranceAbbr"
            [autoDisplayFirst]="false"
        ></app-insurance-company-select-input>
        <app-select-input [form]="form" id="insuranceType" [staticOptions]="insuranceTypeEnumOptions"
            [autoDisplayFirst]="false" valueKey="value"></app-select-input>
        <app-date-input [form]="form" id="insuredSince"></app-date-input>

        <div class="flex gap-small">
            <app-service-doctor-select-input class="flex-1" [form]="form"
                [disabled]="voucherIsBilled()"></app-service-doctor-select-input>
            @if (isAllowed['folder.update']() && !store2.isTerminated() && !voucherIsBilled()) {
                <app-button
                    icon="pi-plus"
                    [pTooltip]="'common.addDoctorButtonTooltip' | translate"
                    (clickEvent)="addNewDoctor($event)"
                ></app-button>
            }
        </div>
        <app-date-input [form]="form" id="issueDate" timeType="startOfDay"></app-date-input>
        <app-date-input [form]="form" id="validTo" timeType="endOfDay"></app-date-input>
        <app-date-input [form]="form" id="closureDate"
            label="database.vouchers.labels.terminationDate"></app-date-input>
        <app-number-input [form]="form" id="sequenceNumber"></app-number-input>

        <app-diagnosis-select-input
            class="fr-4"
            [form]="form"
            id="primaryDiagnosisCode"
            [expertise]="expertise || 0"
            label="inputs.primaryDiagnosisCode"
        ></app-diagnosis-select-input>

        <app-select-input
            [form]="form"
            id="compensationCode"
            [showClear]="true"
            [staticOptions]="(store.compensations$ | async)?.['items'] || []"
            labelKey="description"
            valueKey="code"
        ></app-select-input>

        <div class="flex-column gap-x-small fr-5 secondary-diagnosis-wrapper">
            <app-diagnosis-select-input
                class="flex-1"
                [form]="form"
                id="addSecondaryDiagnosis"
                [expertise]="expertise || 0"
                label="inputs.addSecondaryDiagnosis"
            ></app-diagnosis-select-input>

            <app-table
                [items]="form.value['secondaryDiagnoses'] || []"
                [columns]="columns"
                [hideCheckboxes]="true"
                translatePrefix="voucher.general.secondaryDiagnoses."
                [showSearchBar]="false"
                dataKey="diagnosis.code"
                (deleteCallback)="deleteSecondaryDiagnosis($event)"
            >
                <ng-template pTemplate="reporting" let-item="item">
                    <p-select [options]="voucherSecondaryDiagnosisReportingTypeEnumOptions" [optionLabel]="'name'"
                        [optionValue]="'value'"
                        appendTo="body" [(ngModel)]="item['reporting']">
                        <ng-template pTemplate="item" let-item>
                            {{ item.name | translate }}
                        </ng-template>
                        <ng-template pTemplate="selectedItem" let-item>
                            {{ item.name | translate }}
                        </ng-template>
                    </p-select>
                </ng-template>
                <ng-template pTemplate="code" let-data="data">
                    <p-chip [label]="data"></p-chip>
                </ng-template>
            </app-table>
        </div>

        <app-text-input [form]="form" id="internNote" class="fr-5"></app-text-input>

        @if (folderStore.canEdit()) {
            <app-warn-float-message
                class="fr-5"
                [(visible)]="insuranceNotExists"
            >
                <span>{{ 'voucher.messages.insuranceNotExists' | translate }}</span>
                <app-link-button label="voucher.messages.insuranceNotExists2"
                    (clickEvent)="createPersonInsurance($event, true)"></app-link-button>
                <span>{{ 'voucher.messages.insuranceNotExists3' | translate }}</span>
            </app-warn-float-message>

            <app-warn-float-message
                class="fr-5"
                [(visible)]="insuranceMismatch"
            >
                <span>{{ 'voucher.messages.insuranceMismatch' | translate }}</span>
                <app-link-button label="voucher.messages.insuranceMismatch2"
                    (clickEvent)="updateInsurance($event)"></app-link-button>
                <span>{{ 'voucher.messages.insuranceMismatch3' | translate }}</span>
                <app-link-button label="voucher.messages.insuranceMismatch4"
                    (clickEvent)="createPersonInsurance($event, false)"></app-link-button>
                <span>{{ 'voucher.messages.insuranceMismatch5' | translate }}</span>
            </app-warn-float-message>

            <app-error-float-message
                class="fr-5"
                [(visible)]="datesOverlay"
            >
                <span>{{ 'voucher.messages.datesOverlay' | translate:{ voucher: nextVoucher | formatVoucher } }}</span>
            </app-error-float-message>
        }

        <p-confirmpopup key="insuranceConfirm"></p-confirmpopup>
    </div>

}
